(ns frontend.view.entity-merge.review
  (:require
   [common.entity :as entity]
   [common.localization :as loc]
   [frontend.view.entity-merge.associations :as associations]
   [frontend.view.entity-merge.attachments :as attachments]
   [frontend.view.entity-merge.contact-lists :as contact-lists]
   [frontend.view.entity-merge.entity-info :as entity-info]
   [frontend.view.entity-merge.events :as events]
   [frontend.view.entity-merge.guests :as guests]
   [frontend.view.entity-merge.kpi :as kpi]
   [frontend.view.entity-merge.kyc :as kyc]))

(defn view
  [{:keys [entity-type r-target-id] :as signals}]
  (let [icon (entity/entity-type-icon entity-type)
        result-entity (-> (entity-info/combined-info signals)
                          (assoc :entity/type entity-type
                                 :db/id @r-target-id))]
    [:div
     [:div.infobox.infobox--warning
      [:div.infobox__icon
       [:i.fas.fa-info-circle.mr-2]]
      [:div.infobox__message
       (loc/tr :entity-merge-step/review-info)]]
     (doall
      (for [[step args] (events/review-steps signals)]
        ^{:key (str "review-step-" step "-" args)}
        [:div.my-4
         (case step
           :entity-info
           [entity-info/review signals]

           :associations
           [associations/review signals args]

           :attachments
           [attachments/review signals]

           :guests
           [guests/review signals]

           :kyc-profiles
           [kyc/review signals]

           :kpi
           [kpi/review signals]

           :review nil

           [:div "TODO" step])]))

     [contact-lists/review signals]]))
